import { getService } from 'react-in-angularjs';

export const goToHomePage = () => {
  const utilService = getService('utilService');

  utilService.nextScreen();
  utilService.applyAsyncFunc();
};
